/**
 * Gera ou recupera o device_id do navegador
 * Armazena no localStorage para persistência
 */
export function getOrCreateDeviceId(): string {
  const STORAGE_KEY = 'galatea_device_id'
  const STORAGE_NAME_KEY = 'galatea_device_name'
  
  let deviceId = localStorage.getItem(STORAGE_KEY)
  
  if (!deviceId) {
    deviceId = safeGenerateUUID()
    localStorage.setItem(STORAGE_KEY, deviceId)
  }
  
  // Gerar device_name baseado no navegador
  let deviceName = localStorage.getItem(STORAGE_NAME_KEY)
  if (!deviceName) {
    const ua = navigator.userAgent
    let name = 'Web Browser'
    
    if (ua.includes('Chrome')) name = 'Chrome'
    else if (ua.includes('Firefox')) name = 'Firefox'
    else if (ua.includes('Safari')) name = 'Safari'
    else if (ua.includes('Edge')) name = 'Edge'
    
    deviceName = `${name} - ${navigator.platform}`
    localStorage.setItem(STORAGE_NAME_KEY, deviceName)
  }
  
  return deviceId
}

export function getDeviceName(): string {
  return localStorage.getItem('galatea_device_name') || 'Web Browser'
}

export function isMobileDevice(): boolean {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string') {
      const ua = navigator.userAgent
      if (/Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(ua)) {
        return true
      }
    }
    if (typeof window !== 'undefined') {
      return window.innerWidth < 768
    }
  } catch (e) {
    return false
  }
  return false
}

function safeGenerateUUID(): string {
  const cryptoUuid = tryCryptoRandomUUID()
  if (cryptoUuid) {
    return cryptoUuid
  }
  return fallbackUUID()
}

function tryCryptoRandomUUID(): string | null {
  try {
    if (
      typeof globalThis !== 'undefined' &&
      typeof globalThis.crypto !== 'undefined'
    ) {
      const cryptoObj = globalThis.crypto as Crypto & { randomUUID?: () => string }
      if (typeof cryptoObj.randomUUID === 'function') {
        return cryptoObj.randomUUID()
      }
      if (typeof (cryptoObj as any).getRandomValues === 'function') {
        return uuidFromCrypto(cryptoObj)
      }
    }
  } catch (error) {
    // Logger não disponível neste contexto (utils básico)
    // console.warn('Falha ao gerar crypto.randomUUID, usando fallback', error)  // Comentado - não crítico
  }
  return null
}

function uuidFromCrypto(cryptoObj: Crypto & { getRandomValues: Crypto['getRandomValues'] }): string {
  const buffer = new Uint8Array(16)
  cryptoObj.getRandomValues(buffer)

  buffer[6] = (buffer[6] & 0x0f) | 0x40
  buffer[8] = (buffer[8] & 0x3f) | 0x80

  const hex = Array.from(buffer, (b) => b.toString(16).padStart(2, '0'))
  return (
    hex.slice(0, 4).join('') +
    hex.slice(4, 6).join('') +
    '-' +
    hex.slice(6, 8).join('') +
    '-' +
    hex.slice(8, 10).join('') +
    '-' +
    hex.slice(10, 12).join('') +
    '-' +
    hex.slice(12, 16).join('')
  )
}

function fallbackUUID(): string {
  let timestamp = new Date().getTime()
  let performanceTime =
    (typeof performance !== 'undefined' &&
      typeof performance.now === 'function' &&
      performance.now() * 1000) ||
    0

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    let random = Math.random() * 16

    if (timestamp > 0) {
      random = (timestamp + random) % 16
      timestamp = Math.floor(timestamp / 16)
    } else {
      random = (performanceTime + random) % 16
      performanceTime = Math.floor(performanceTime / 16)
    }

    const value = char === 'x' ? random : (random & 0x3) | 0x8
    return Math.floor(value).toString(16)
  })
}
